import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { KeyboardDatePicker } from "@material-ui/pickers";
import MakeAPICall from "../../apiCalls/common";
import { getPostsListApiRoute, markAllPostsReadApiRoute } from "../../apiRoutes";
import { converToUtc, getFormattedDate } from "../../utils/dateTimeHelper";
import { sortData } from "../../utils/commonMethods";
import appRoutes from "../../routes/appRoutes";

import Loader from "../../components/loader";
import Button from "../../components/button";
import CustomDataTable from "../../components/datatable/customDataTable";
import CustomModal from "../../components/modal";
import ICCheckbox from "../../components/form/checkbox";

import DEFAULT_PIC from "../../assets/images/default-picture.png";

// redux
import { setForumReadComments, setForumReadTopics } from "../../reduxStore/actions/serverConstants";

const ForumList = props => {
  let history = useHistory();
  const user = props.auth.user;
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [myPostsCheckbox, setMyPostsCheckbox] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  // const [readAllPostsParams, setReadAllPostsParams] = useState(null);
  const [getPostsParams, setGetPostsParams] = useState(null);
  const [currFilters, setCurrFilters] = useState(
    props.location && props.location.state && props.location.state.currPageNo
      ? {
          skip: props.location.state.currPageNo.skip,
          limit: props.location.state.currPageNo.limit,
          userId: user ? user._id : "",
          userType: "Admin"
        }
      : {
          skip: 0,
          limit: 10,
          userId: user ? user._id : "",
          userType: "Admin"
        }
  );
  const [postsList, setPostsList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [modalText, setModalText] = useState("");
  const [showTextModal, setShowTextModal] = useState(false);

  const tableHeaders = [
    {
      key: "topic",
      value: "Topic"
    },
    { key: "message", value: "Preview" },
    { key: "createdAt", value: "Date Posted" },
    { key: "commentsCount", value: "Comments" },
    { key: "fullName", value: "Posted By" }
  ];

  const createForumPost = () => {
    history.push(appRoutes.createForumPost);
  };

  const goToPostDetailPage = id => {
    history.push(appRoutes.forumPostDetails + "/" + id, {
      currPageNo: currFilters
    });
  };

  const markAllRead = () => {
    setIsProcessing(true);

    setGetPostsParams({
      reqType: "POST",
      reqUrl: markAllPostsReadApiRoute,
      successCallback: async res => {
        props.setForumReadTopics(0);
        props.setForumReadComments(0);
        getPosts();
      },
      failureCallback: err => {
        setIsProcessing(false);
      }
    });
  };


  const getPosts = () => {
    setIsProcessing(true);

    setGetPostsParams({
      reqType: "GET",
      reqUrl: getPostsListApiRoute,
      params: currFilters,
      successCallback: async res => {
        setIsProcessing(false);
        let list = [];
        await res.data.data.posts.forEach(item => {
          let dt = {};

          dt.id = item._id;
          dt.topic =
            item.topic.length > 40
              ? item.topic.slice(0, 40) + "..."
              : item.topic;
          dt.message =
            item.message.length > 40
              ? item.message.slice(0, 40) + "..."
              : item.message;
          dt.tags = item.tags;
          dt.createdAt = getFormattedDate(item.createdAt);
          dt.readBy= item.readBy;
          dt.unreadComments = item.unreadComments;
          dt.unreadReplyComments = item.unreadReplyComments;
          dt.commentsCount = item.commentsCount || 0;

          // dt.fullName = item.userInfo.fullName;
          // dt.profilePic = item.userInfo && item.userInfo.profilePic && item.userInfo.profilePic.original ? item.userInfo.profilePic.original : item.userInfo.profilePic;

          // dt.fullName = item.userInfo.fullName;
          dt.fullName = '';
          dt.profilePic = DEFAULT_PIC;
          if (item.adminId) {
            dt.fullName = `${item.adminId.firstName || ''} ${item.adminId.lastName}`;
            dt.profilePic = item.adminId.profilePic.original;
          } else if (item.doctorId) {
            dt.fullName = `${item.doctorId.firstName || ''} ${item.doctorId.lastName}`;
            dt.profilePic = item.doctorId.profilePic.original;
          } else {
            dt.fullName = item.userInfo.fullName; // this needed just incase for old data
            dt.profilePic = item.userInfo.profilePic; // this needed just incase for old data
          }

          list.push(dt);
        });
        setPostsList(list);
        setTotalRecords(res.data.data.count);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // const readAllPosts = () => {
  //   setReadAllPostsParams({
  //     reqType: "GET",
  //     reqUrl: readForumPostsAPI,
  //     successCallback: async res => {
  //       console.log("All posts read success: ", res.data);
  //       props.setForumReadTopics(0);
  //     },
  //     failureCallback: err => {
  //     }
  //   });
  // };

  useEffect(() => {
    getPosts();
  }, [currFilters]);

  // restore the previous page state
  useEffect(() => {
    if (
      props.location.state &&
      props.location.state.currPageNo &&
      props.location.state.currPageNo !== null
    ) {
      setCurrFilters({
        skip: props.location.state.currPageNo.skip,
        limit: props.location.state.currPageNo.limit,
        userId: user ? user._id : "",
        userType: "Admin"
      });
    }
  }, []);

  const handleStartDateChange = date => {
    setStartDate(date);
  };

  const handleEndDateChange = date => {
    setEndDate(date);
  };

  const handleCheckboxChange = e => {
    setMyPostsCheckbox(e.target.checked);

    let newFilter = Object.assign({}, currFilters);
    newFilter.getMyPosts = e.target.checked;
    setCurrFilters(newFilter);
  };

  const clearFilter = () => {
    setStartDate(null);
    setEndDate(null);
    let newFilter = Object.assign({}, currFilters);
    newFilter.skip = 0;
    if (newFilter.startDate) {
      delete newFilter.startDate;
    }
    if (newFilter.endDate) {
      delete newFilter.endDate;
    }
    setCurrFilters(newFilter);
  };

  const setTableFilters = filters => {
    let newFilter = Object.assign({}, currFilters);
    newFilter.limit = filters.limit;
    newFilter.skip = filters.skip;
    newFilter.text = filters.text;

    setCurrFilters(newFilter);
  };

  const sortTableDataByColumn = SelColumn => {
    let sortedData = sortData(SelColumn.column, SelColumn.order, postsList);
    setPostsList(sortedData);
  };

  const applySelectedFilter = () => {
    let newFilter = Object.assign({}, currFilters);

    newFilter.skip = 0;

    if (newFilter.startDate) {
      delete newFilter.startDate;
    }
    if (newFilter.endDate) {
      delete newFilter.endDate;
    }

    newFilter.startDate = converToUtc(startDate);
    let dt = new Date(
      endDate.get("year"),
      endDate.get("month"),
      endDate.get("date") + 1,
      0,
      0,
      0
    ).toISOString();
    newFilter.endDate = converToUtc(dt);
    setCurrFilters(newFilter);
  };

  function shouldHighlightRow(row) {
    return !row.readBy?.includes(user._id);
  }

  function getRowClass(row) {
    return shouldHighlightRow(row) ? "table-element-highlight cursor-pointer" : "cursor-pointer";
  }

  function shouldHighlightCommentsCell(row) {
    console.log("Row is here: ", row);
    return !!row.unreadComments?.unreadComments || !!row.unreadReplyComments?.unreadComments;
  }

  function getCommentsCellClass(row) {
    return shouldHighlightCommentsCell(row) ? "table-element-highlight cursor-pointer" : "cursor-pointer";
  }

  return (
    <Fragment>
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <div className="view-ticket-container">
          <CustomModal
            useOneButton={true}
            cancelText="OKAY"
            openModal={showTextModal}
            cancelEvent={() => {
              setShowTextModal(false);
              setModalText("");
            }}
            modalBodyContent={<p className="text-center mb-0">{modalText}</p>}
          />

          <div className="d-flex flex-row flex-wrap justify-content-between">
            <h3>Forum</h3>
            <div className="d-flex flex-row align-items-end">
              &nbsp;&nbsp;&nbsp;&nbsp;
              <Button
                clickEvent={markAllRead}
                title="Mark All Read"
              />
              <Button
                className="ml-2 ic-btn-transparent-navy-blue"
                clickEvent={createForumPost}
                title="Post New Topic"
              />
            </div>
          </div>
          <div className="d-flex flex-row flex-wrap mt-4">
            <div className="d-flex flex-row align-items-end">
              <div className="d-flex flex-row align-items-end">
                <div>
                  <KeyboardDatePicker
                    name="startDate"
                    style={{ width: "145px" }}
                    autoOk
                    variant="inline"
                    mask="__-__-____"
                    format="DD-MM-YYYY"
                    label="Start Date"
                    value={startDate}
                    onChange={date => handleStartDateChange(date)}
                  />
                  <KeyboardDatePicker
                    name="endDate"
                    style={{ width: "145px", marginLeft: "20px" }}
                    autoOk
                    variant="inline"
                    mask="__-__-____"
                    format="DD-MM-YYYY"
                    label="End Date"
                    value={endDate}
                    onChange={date => handleEndDateChange(date)}
                  />
                </div>
                {(startDate !== null || endDate !== null) && (
                  <Fragment>
                    <button
                      style={{ minWidth: "30px", width: "30px" }}
                      className="insta-button-primary ml-3"
                      onClick={applySelectedFilter}
                    >
                      <i className="fas fa-arrow-right" aria-hidden="true"></i>
                    </button>
                    <button
                      style={{ minWidth: "30px", width: "30px" }}
                      className="insta-button-primary ic-btn-red ml-3"
                      onClick={clearFilter}
                    >
                      <i className="fa fa-times" aria-hidden="true"></i>
                    </button>
                  </Fragment>
                )}
              </div>
            </div>

            <div className="d-flex flex-row align-items-end forum-list-checkbox-container">
              <p className="mb-0 mr-4">My Posts</p>
              <ICCheckbox
                style={{ padding: 0 }}
                name="myPostsCheckbox"
                inputProps={{ "aria-label": "primary checkbox" }}
                value={myPostsCheckbox}
                onChange={handleCheckboxChange}
              />
            </div>
          </div>
          <CustomDataTable
            totalRecords={totalRecords}
            headers={tableHeaders}
            setFilters={setTableFilters}
            sortData={sortTableDataByColumn}
            tabFilters={currFilters}
            searchColumnText="Search all posts:"
          >
            {postsList.map((post, index) => (
              <tr
                className={getRowClass(post)}
                key={index}
                onClick={e => {
                  e.preventDefault();
                  goToPostDetailPage(post.id);
                }}
              >
                <td>{post.topic}</td>
                <td><span dangerouslySetInnerHTML={{__html: post.message}} /></td>
                <td>{post.createdAt}</td>
                <td  className={getCommentsCellClass(post, false)}>
                  {post.commentsCount}&nbsp;&nbsp;&nbsp;
                  <i className="far fa-comment font-col-primary"></i>
                </td>
                <td>
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <img
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "cover"
                      }}
                      className="rounded-circle user-pic"
                      src={post.profilePic}
                      alt="user-pic"
                    />
                    <p className="user-name">{post.fullName}</p>
                  </div>
                </td>
              </tr>
            ))}
          </CustomDataTable>
          {/* API Call */}
          {/*<MakeAPICall apiParam={readAllPostsParams} />*/}
          <MakeAPICall apiParam={getPostsParams} />
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  auth: state.auth
});

const mapDispatchToProps = dispatch => ({
  setForumReadTopics: data => dispatch(setForumReadTopics(data)),
  setForumReadComments: data => dispatch(setForumReadComments(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(ForumList);
